module.exports = __webpack_public_path__ + "img/ai-gateways.ff37006a.jpg";